/**
 *
 * @return updateScenarioTemplateで渡すdata
 *
/* eslint-disable */
function makeUpdateTemplateData(selectTemplateId, scenarioTable, scenario, notice) {
  const data = {
    selectTemplateId: selectTemplateId,
    scenarioTable: newScenarioTableTemplate(scenarioTable),
    scenario: scenario,
    notice: notice,
  }
  return data
}

function newScenarioTableTemplate(scenario) {
  let scenarioTable = scenario
  for (const i in scenarioTable) {
    if (scenarioTable[i].beforenode === scenario.beforenode) {
      scenarioTable[i] = scenario[0]
    }
  }
  return scenarioTable
}

export default makeUpdateTemplateData



// WEBPACK FOOTER //
// ./src/functions/makeUpdateTemplateData.js